<template>
    <div class="foot">
        <div class="bqj-home-footer-content">
            <div class="footer-content-left">
                <div>
                    <p>关于我们</p>
                    <ul>
                        <li @click="aboutAs" style="cursor:pointer">公司简介</li>
<!--                        <li @click="wzMap" style="cursor:pointer">网站地图</li>-->
                        <!-- <li>资质荣誉</li>
                        <li>发展历程</li>
                        <li>服务商登录</li>
                        <li>合作伙伴平台</li> -->
                    </ul>
                </div>
                <div>
                    <p>法律声明</p>
                    <ul>
                        <li @click="lawLink(1)" style="cursor:pointer">平台免责声明</li>
                        <li @click="lawLink(2)" style="cursor:pointer">用户注册协议</li>
                        <li @click="lawLink(3)" style="cursor:pointer">隐私政策</li>
                        <li @click="lawLink(4)" style="cursor:pointer">交易风险提示书</li>
                    </ul>
                </div>
                <div>
                    <p>联系我们</p>
                    <ul>
                        <li>客服 : 17316071137，17316071136</li>
                        <li>工作时间：周一至周五 8:30-18:00</li>
                        <li style="cursor:pointer" @click="linkPerson">在线客服：点击咨询</li>
                        <li>商务合作：service@bqj.cn</li>
                    </ul>
                </div>
            </div>
            <div class="footer-content-right">
                <ul>
                    <li><img src="../../assets/weibo.png" alt='版权登记'/><span>微博</span></li>
                    <li><img src="../../assets/app.png" alt='版权登记'/><span>下载app</span></li>
                    <li><img src="../../assets/wchart.png" alt='版权登记'/><span>公众平台</span></li>
                </ul>
            </div>
        </div>
        <div class="bqj-home-footer-bottom">
            <div class="bqj-homefr">
                <div class="homefr_l">
                    <span>北京版全家科技发展有限公司</span>
                    <span>版权所有©2016-2021 京ICP备<a class="footer_link" href="https://beian.miit.gov.cn/#/Integrated/index"
                                              target="_black">16069421号-2</a></span>
                    <span>京公网安备<a class="footer_link" target="_black"
                               href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033014">11010502033014号</a></span>
                </div>
                <div class="homefr_r">公司地址：北京市海淀区京玺文化创意创新园A16栋D座</div>
                <!-- <div class="bqj-homefr-left">
                    <p>北京版全家科技发展有限公司</p>
                    <p>版权所有©2016-2020 京ICP备<a class="footer_link" href="https://beian.miit.gov.cn/#/Integrated/index"
                                              target="_black">16069421号-2</a></p>
                </div>
                <div class="bqj-homefr-right">
                    <p>北京市海淀区京玺文化创意创新园A16栋D座</p>
                    <p>京公网安备<a class="footer_link" target="_black"
                               href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033014">11010502033014号</a>
                    </p>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import {bqjUrl} from "@/config/config"
    export default {
        name: "homeFooter",
        methods: {
            aboutAs() {
                this.$router.push({name: 'aboutUs'})
            },
            wzMap() {
                window.open("/sitemap.xml")
            },
            lawLink(type) {
                switch (type) {
                    case 1:
                        window.open('/instrument/1');
                        break;
                    case 2:
                        window.open('/instrument/2');
                        break;
                    case 3:
                        window.open('/instrument/3');
                        break;
                    case 4:
                        window.open('/instrument/4');
                        break;
                    default:
                        break;
                }
            },
            linkPerson() {

                if (typeof (_MEIQIA) != 'undefined') {
                    _MEIQIA('showPanel');
                } else {
                    console.log("美洽开始初始化" + new Date().getTime());
                    (function (m, ei, q, i, a, j, s) {
                        m[i] = m[i] || function () {
                            (m[i].a = m[i].a || []).push(arguments)
                        };
                        j = ei.createElement(q),
                            s = ei.getElementsByTagName(q)[0];
                        j.async = false;
                        j.charset = 'UTF-8';
                        j.src = '//static.meiqia.com/dist/meiqia.js';
                        s.parentNode.insertBefore(j, s);
                    })(window, document, 'script', '_MEIQIA');
                    _MEIQIA('manualInit');
                    _MEIQIA('entId', '6351b02e1b6975b5b7bb282762244a9f');
                    //隐藏美洽客服按钮
                    _MEIQIA('withoutBtn');
                    // 初始化成功时的回调
                    _MEIQIA('allSet', this.footMeiqiaCallBack);
                    //创建美洽
                    _MEIQIA('init');
                    console.log("美洽初始化结束" + new Date().getTime());
                    _MEIQIA('showPanel');
                }
            },
            footMeiqiaCallBack() {
                console.log("初始化回调成功" + new Date().getTime());
            }
        },
    };
</script>

<style lang="less">
    .foot {
        height: 302px;
        background: rgba(30, 30, 30, 1);
        /*min-width: 1366px;*/
        width: 100%;

        .bqj-home-footer-content {
            height: 261px;
            clear: both;
            display: flex;
            width: 1200px;
            padding-top:52px;
            margin: 0 auto;
            background: rgba(30, 30, 30, 1);
            // border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            border: none;

            .footer-content-right {
                // margin-left: 230px;
                width: 485px;
                margin-left: 0;
                font-size: 12px;
                color: #CCCCCC;
                ul {
                    margin-top:32px;
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    li {
                        list-style: none;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        margin-right: 0px;
                        margin-left: 65px;

                        span {
                            margin-top: 15px;
                        }
                    }

                    li:last-child {
                        margin-right: 0px;
                    }
                }

                img {
                    width: 94px;
                    height: 94px;
                }
            }

            .footer-content-left {
                display: flex;
                justify-content: flex-start;
                flex: 1;
                div:first-child {
                    margin-right: 80px;
                }

                div:last-child {
                    margin-left: 80px;
                }

                p {
                    height: 28px;
                    font-size: 20px;
                    font-weight: 400;
                    line-height: 28px;
                    letter-spacing: 2px;
                    margin-bottom: 15px;
                    color: rgba(255, 255, 255, 1);
                }

                ul {
                    width: 100%;

                    li {
                        letter-spacing: 2px;
                        list-style: none;
                        margin-bottom:13px;
                        white-space: nowrap;
                        font-size: 12px;
                        color: #CCCCCC;
                        line-height: 17px;

                        a {
                            color: #fff;
                            cursor: pointer;
                        }
                    }
                }
            }
        }

        .bqj-home-footer-bottom {
            // border-top:1px solid rgba(255,255,255,0.1);
            height: 40px;
            overflow: hidden;
            background: #000;
            .bqj-homefr {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                background: #000;
                padding-bottom: 20px;
                display: flex;
                font-size: 12px;
                color: #CCCCCC;
                line-height:40px;
                .homefr_l{
                    flex:1;
                    span{
                        margin-right: 14px;
                    }
                }
                .homefr_r{
                    width: 300px;
                    text-align: right;
                }
                p {
                    height: 22px;
                    font-size: 16px;
                    font-weight: 400;
                    color: rgba(191, 191, 191, 1);
                    line-height: 22px;
                    letter-spacing: 2px;
                }

                .bqj-homefr-left {
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;

                    p:last-child {
                        margin-top: 15px;
                    }
                }

                .bqj-homefr-right {
                    display: flex;
                    flex-direction: column;
                    margin-top: 20px;
                    text-align: right;

                    p:last-child {
                        margin-top: 15px;
                    }
                }
            }

            .footer_link {
                color: inherit;
                text-decoration: underline;
            }
        }
    }
</style>
